import * as React from 'react';
import { Config, ExtractConfig } from './open-search/helper';
import FacetedSearchOpenSearchView from './open-search/partials/FacetedSearchOpenSearchView';
import { Placeholder } from './open-search/partials/layouts';

export default function FacetedSearchOpenSearch(props) {
  const {settings = {}} = props;

  const activeConfig = ExtractConfig(settings);
  if (!activeConfig) {
    return <Placeholder/>
  }

  if (activeConfig?.provider === Config.Providers.OpenSearch) {
    return <FacetedSearchOpenSearchView config={activeConfig}/>;
  }

  return <Placeholder/>
}
